import { Component } from '@angular/core';
import { IDialog } from '@app/shared/services/dialogs/dialog';
import { IOkDialogConfig } from '@app/shared/services/dialogs/ok-dialog/ok-dialog-config';
import { OkDialogResult } from '@app/shared/services/dialogs/ok-dialog/ok-dialog-result.enum';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-ok-dialog',
  templateUrl: './ok-dialog.component.html',
  styleUrls: ['./ok-dialog.component.scss']
})
export class OkDialogComponent implements IDialog {

  subject: Subject<OkDialogResult>;
  messageTranslationKey: string;
  messageTranslationKeyArgs: any = {};
  dialogConfig: IOkDialogConfig;

  constructor(private bsModalRef: BsModalRef) {}

  okClicked() {
    this.notifyAndClose(OkDialogResult.Ok);
  }

  onCloseClicked() {
    this.notifyAndClose(OkDialogResult.Close);
  }

  private notifyAndClose(status: OkDialogResult) {
    this.subject.next(status);
    setTimeout(() => {
      this.subject.complete();
    }, 0);
    this.bsModalRef.hide();
  }

}
